const pageNameKey = "addNewMachineDrawerModal";

export const addNewMachineDrawerModalEn = {
  [pageNameKey]: {
    title: "Adding Machine (1/2)",
    sectionTitle: "Machine Onboarding (1/2)",
    stepGateway: "Gateway",
    stepMachine: "Machine",
    stepThingsOs: "Things OS",
    gatewayLabel: "Gateway Connected to the Machine",
    gatewayPlaceholder: "Search gateways...",
    noGatewaysFound: "No gateways found",
    machineNameLabel: "Machine Name",
    hostOrIpAddressLabel: "Machine Primary Hostname/IP Address",
    help: "Help",
    machineNameHelpText:
      "You will find your machine by this name in Things OS.",
    ipAddressHelpText:
      "Enter the hostname or IP address that the gateway can use to access the machine over the network.",
    connectButton: "Connect",
    invalidIpAddressErrorMessage: "Please enter a valid hostname or IP address",
    continueMachineSkillsButton: "Continue to Machine Skills",
    titleStepTwo: "Adding Machine (2/2)",
    sectionTitleStepTwo: "Adding Machine Skills",
    machineSkillsDescription:
      "Machine detection identified the following machine skills: {skills}. Enable the required skills to complete the setup.",
    installAndFinishSetupButton: "Install And Finish Setup",
    finishSetupWithoutSkillsButton: "Finish Setup Without Machine Skills",
    machineIpReachable: "Machine hostname/IP reachable",
    checkingMachineAvailability: "Checking machine availability",
    creatingMachine: "Creating machine",
    skillsIdentified: "Skills identified",
    noMachineSkillsFoundMessage:
      "No machine skills automatically (e.g., OPC UA, VNC) found",
    machineIpAddressMismatchErrorMessage: "Hostname/IP does not match",
    skillsNotAvailableErrorMessage: "Skills not available",
    operationPendingWarningMessage:
      "Connection state is still in IDLE or IN_PROGRESS - You might see the source appear in the list if the process is concluded successfully.",
    machineCreationTimeoutWarningMessage:
      "Machine creation timed out. The gateway did not respond in time. If the machine does not appear in the machine list, please try creating it again.",
    operationTimedOutErrorMessage: "The connection timed out.",
    operationFailureErrorMessage: "The connection failed.",
    operationBackendFailureErrorMessage:
      "A backend error occurred while checking the connection.",
    createMachineFailedErrorMessage: "Failed to create machine.",
    certificateGenerationFailedErrorMessage:
      "Failed to generate the certificate. Please try again.",
    skillInstallSuccessMessage: "Machine skills installed successfully",
    invalidPortErrorMessage: "Please enter a valid 2 to 5 digit port",
    rpcDsnLabel: "DSN",
    rpcPortHelpText:
      "This is the port the gateway uses to access the machine's RPC server for Things Twin Data.",
    invalidRpcDsnErrorMessage: "Please enter a valid DSN address",
    showProtocol: "Show Protocol",
    hideProtocol: "Hide Protocol",
    getSupport: "Get Support",
    statusIconAltText: "Status icon",
    opcUaErrorDetailsTitle: "OPC UA error details",
    opcUaConnectionSetupIdleTitle:
      "OPC UA connection setup remained in idle state",
    opcUaConnectionSetupIdleDetail:
      "The OPC UA connection setup to server {endpoint} did not complete and remained in the Idle state. No connection to the OPC UA server was established.",
    opcUaConnectionSetupIdleRecommendedAction:
      "Verify that the OPC UA server is running, the endpoint configuration is correct, and the network connection is available. Then retry the connection.",
    titleSummary: "Adding Machine (Summary)",
    sectionTitleSummary: "Machine Onboarding Summary",
    summaryStatusLabel: "Status",
    summaryInstalledSkillsLabel: "Installed skills",
    summaryFailedSkillsLabel: "Failed skills",
    summarySkippedSkillsLabel: "Skipped skills",
    summaryFinishButton: "Add Another Machine",
    summaryGoToNewMachineButton: "Go to New Machine",
    summaryRetryButton: "Retry",
    summaryUpdateAndRetryButton: "Update and Retry Installation",
    installedSkillLabel: "Installed",
    installedSkillTooltip: "{skill} skill is installed.",
    summaryStatusSuccess: "Setup completed",
    summaryStatusPartialSuccess: "Setup completed with some failures",
    summaryStatusFailed: "Setup failed",
    summaryStatusSkipped: "Setup completed without machine skills",
    thingsSupportTitle: "Things Support",
    thingsSupportDescription:
      "This machine skill offers users to securely view and control a machine's human-machine interface remotely in real time as if they were there.",
    thingsTwinTitle: "Things Twin",
    thingsTwinDescription:
      "The Digital Twin creates a virtual representation of the machine, continuously synchronized with live data to monitor, analyze, and optimize performance.",
    readMoreLabel: "Read more",
    readLessLabel: "Read less",
    vncPortLabel: "VNC Port",
    vncPortPlaceholder: "e.g. 5900",
    vncPortHelpText:
      "This is the port the gateway uses to access the machine's VNC server for HMI screen sharing.",
    portIsAvailableLabel: "Port is available",
    clearPortButtonLabel: "Clear port",
    opcUaPortHelpText:
      "This is the port the gateway uses to access the machine's OPC UA server for Things Twin Data.",
    connectionSectionTitle: "Connection",
    connectionOpcUaDescription:
      "Specify the listening port of the OPC UA server.",
    opcUaPortPlaceholder: "e.g. 4840",
    encryptionSectionTitle: "Encryption",
    encryptionDescription:
      "Select how client-server data is protected, including signing and encryption.",
    loginSectionTitle: "Login",
    loginDescription:
      "Set how the gateway identifies to the server: anonymously or with credentials.",
    applicationCertificateSectionTitle: "Application Certificate",
    applicationCertificateDescription:
      "Use a certificate to establish a secure channel between gateway and server.",
    securityModeLabel: "Mode",
    securityPolicyLabel: "Policy",
    usernameLabel: "Username",
    passwordLabel: "Password",
    clientCertificateLabel: "Client Certificate (Base64)",
    clientCertificatePrivateKeyLabel: "Client Certificate Private Key (Base64)",
    clientCertificatePasswordLabel: "Client Certificate Password",
    serverPublicKeyLabel: "Server Public Key",
    anonymousTab: "Anonymous",
    userLoginTab: "User Login",
    pleaseFixFieldsLabel: "Please fix the following fields",
  },
};

export const addNewMachineDrawerModalPtBr = {
  [pageNameKey]: {
    title: "Adicionando máquina (1/2)",
    sectionTitle: "Integração da máquina (1/2)",
    stepGateway: "Gateway",
    stepMachine: "Máquina",
    stepThingsOs: "Things OS",
    gatewayLabel: "Gateway conectado à máquina",
    gatewayPlaceholder: "Buscar gateways...",
    noGatewaysFound: "Nenhum gateway encontrado",
    machineNameLabel: "Nome da máquina",
    hostOrIpAddressLabel: "Endereço principal de hostname/IP da máquina",
    help: "Ajuda",
    machineNameHelpText:
      "Você encontrará sua máquina por esse nome no Things OS.",
    ipAddressHelpText:
      "Insira o hostname ou endereço IP que o gateway pode usar para acessar a máquina pela rede.",
    connectButton: "Conectar",
    invalidIpAddressErrorMessage: "Insira um hostname ou endereço IP válido",
    continueMachineSkillsButton: "Continuar para habilidades da maquina",
    titleStepTwo: "Adicionando máquina (2/2)",
    sectionTitleStepTwo: "Habilidades da máquina (2/2)",
    machineSkillsDescription:
      "A detecção da máquina identificou as seguintes habilidades: {skills}. Ative as habilidades necessárias para concluir a configuração.",
    installAndFinishSetupButton: "Instalar e concluir configuracao",
    finishSetupWithoutSkillsButton: "Concluir sem habilidades da maquina",
    machineIpReachable: "Hostname/IP da maquina acessivel",
    checkingMachineAvailability: "Verificando a disponibilidade da máquina",
    creatingMachine: "Criando máquina",
    skillsIdentified: "Habilidades identificadas",
    noMachineSkillsFoundMessage:
      "Nenhuma habilidade de máquina (por exemplo, OPC UA, VNC) encontrada automaticamente",
    machineIpAddressMismatchErrorMessage: "Hostname/IP nao corresponde",
    skillsNotAvailableErrorMessage: "Habilidades nao disponiveis",
    operationPendingWarningMessage:
      "O estado da conexao ainda e IDLE ou IN_PROGRESS - A origem pode aparecer na lista se o processo for concluido com sucesso.",
    machineCreationTimeoutWarningMessage:
      "A criação da máquina expirou. O gateway não respondeu a tempo. Se a máquina não aparecer na lista de máquinas, tente criá-la novamente.",
    operationTimedOutErrorMessage: "A conexao expirou.",
    operationFailureErrorMessage: "A conexao falhou.",
    operationBackendFailureErrorMessage:
      "Ocorreu um erro de backend ao verificar a conexao.",
    createMachineFailedErrorMessage: "Falha ao criar a maquina.",
    certificateGenerationFailedErrorMessage:
      "Falha ao gerar o certificado. Tente novamente.",
    skillInstallSuccessMessage: "Habilidades da maquina instaladas com sucesso",
    invalidPortErrorMessage: "Insira uma porta valida entre 1 e 65535",
    rpcDsnLabel: "DSN",
    rpcPortHelpText:
      "Esta é a porta que o gateway usa para acessar o servidor RPC da máquina para os dados do Things Twin.",
    invalidRpcDsnErrorMessage: "Insira um endereco DSN valido",
    showProtocol: "Mostrar protocolo",
    hideProtocol: "Ocultar protocolo",
    getSupport: "Obter suporte",
    statusIconAltText: "Icone de status",
    opcUaErrorDetailsTitle: "Detalhes do erro OPC UA",
    opcUaConnectionSetupIdleTitle:
      "A configuração da conexão OPC UA permaneceu no estado ocioso",
    opcUaConnectionSetupIdleDetail:
      "A configuração da conexão OPC UA com o servidor {endpoint} não foi concluída e permaneceu no estado Ocioso. Nenhuma conexão com o servidor OPC UA foi estabelecida.",
    opcUaConnectionSetupIdleRecommendedAction:
      "Verifique se o servidor OPC UA está em execução, se a configuração do endpoint está correta e se a conexão de rede está disponível. Em seguida, tente novamente.",
    titleSummary: "Adicionando máquina (Resumo)",
    sectionTitleSummary: "Resumo da configuração da máquina",
    summaryStatusLabel: "Status",
    summaryInstalledSkillsLabel: "Habilidades instaladas",
    summaryFailedSkillsLabel: "Habilidades com falha",
    summarySkippedSkillsLabel: "Habilidades ignoradas",
    summaryFinishButton: "Adicionar outra máquina",
    summaryGoToNewMachineButton: "Ir para a nova máquina",
    summaryRetryButton: "Tentar novamente",
    summaryUpdateAndRetryButton: "Atualizar e tentar a instalação novamente",
    installedSkillLabel: "Instalado",
    installedSkillTooltip: "A habilidade {skill} está instalada.",
    summaryStatusSuccess: "Configuração concluída",
    summaryStatusPartialSuccess: "Configuração concluída com falhas",
    summaryStatusFailed: "Configuração falhou",
    summaryStatusSkipped: "Configuração sem habilidades da máquina",
    thingsSupportTitle: "Things Support",
    thingsSupportDescription:
      "Esta habilidade da máquina permite que os usuários visualizem e controlem com segurança a interface homem-máquina (IHM) de uma máquina remotamente, em tempo real, como se estivessem no local.",
    thingsTwinTitle: "Things Twin",
    thingsTwinDescription:
      "O Digital Twin cria uma representação virtual da máquina, sincronizada continuamente com dados em tempo real para monitorar, analisar e otimizar o desempenho.",
    readMoreLabel: "Leia mais",
    readLessLabel: "Leia menos",
    vncPortLabel: "Porta VNC",
    vncPortPlaceholder: "ex.: 5900",
    vncPortHelpText:
      "Esta é a porta que o gateway usa para acessar o servidor VNC da máquina para compartilhamento de tela HMI.",
    portIsAvailableLabel: "A porta está disponível",
    clearPortButtonLabel: "Limpar porta",
    opcUaPortHelpText:
      "Esta é a porta que o gateway usa para acessar o servidor OPC UA da máquina para os dados do Things Twin.",
    connectionSectionTitle: "Conexão",
    connectionOpcUaDescription:
      "Especifique a porta de escuta do servidor OPC UA.",
    opcUaPortPlaceholder: "ex.: 4840",
    encryptionSectionTitle: "Criptografia",
    encryptionDescription:
      "Selecione como os dados cliente-servidor são protegidos, incluindo assinatura e criptografia.",
    loginSectionTitle: "Login",
    loginDescription:
      "Defina como o gateway se identifica ao servidor: anonimamente ou com credenciais.",
    applicationCertificateSectionTitle: "Certificado do aplicativo",
    applicationCertificateDescription:
      "Use um certificado para estabelecer um canal seguro entre o gateway e o servidor.",
    securityModeLabel: "Modo",
    securityPolicyLabel: "Política",
    usernameLabel: "Nome de usuário",
    passwordLabel: "Senha",
    clientCertificateLabel: "Certificado do cliente (Base64)",
    clientCertificatePrivateKeyLabel:
      "Chave privada do certificado do cliente (Base64)",
    clientCertificatePasswordLabel: "Senha do certificado do cliente",
    serverPublicKeyLabel: "Chave pública do servidor",
    anonymousTab: "Anônimo",
    userLoginTab: "Login do usuário",
    pleaseFixFieldsLabel: "Corrija os seguintes campos",
  },
};

export const addNewMachineDrawerModalDe = {
  [pageNameKey]: {
    title: "Maschine hinzufügen (1/2)",
    sectionTitle: "Maschinen-Onboarding (1/2)",
    stepGateway: "Gateway",
    stepMachine: "Maschine",
    stepThingsOs: "Things OS",
    gatewayLabel: "Mit der Maschine verbundenes Gateway",
    gatewayPlaceholder: "Gateways suchen...",
    noGatewaysFound: "Keine Gateways gefunden",
    machineNameLabel: "Maschinenname",
    hostOrIpAddressLabel: "Primäre Hostname/IP-Adresse der Maschine",
    help: "Hilfe",
    machineNameHelpText:
      "Sie finden Ihre Maschine unter diesem Namen in Things OS.",
    ipAddressHelpText:
      "Geben Sie den Hostnamen oder die IP-Adresse ein, die das Gateway verwenden kann, um über das Netzwerk auf die Maschine zuzugreifen.",
    connectButton: "Verbinden",
    invalidIpAddressErrorMessage:
      "Bitte geben Sie einen gültigen Hostnamen oder eine gültige IP-Adresse ein",
    continueMachineSkillsButton: "Weiter zu Maschinen-Skills",
    titleStepTwo: "Maschine hinzufügen (2/2)",
    sectionTitleStepTwo: "Maschinen-Skills (2/2)",
    machineSkillsDescription:
      "Die Maschinenerkennung hat die folgenden Maschinen-Skills identifiziert: {skills}. Aktivieren Sie die erforderlichen Skills, um das Setup abzuschließen.",
    installAndFinishSetupButton: "Installieren und Setup abschliessen",
    finishSetupWithoutSkillsButton: "Setup ohne Maschinen-Skills beenden",
    machineIpReachable: "Maschinen-Hostname/IP erreichbar",
    checkingMachineAvailability: "Maschinenverfügbarkeit wird geprüft",
    creatingMachine: "Maschine wird erstellt",
    skillsIdentified: "Skills erkannt",
    noMachineSkillsFoundMessage:
      "Keine Maschinen-Skills (z. B. OPC UA, VNC) automatisch gefunden",
    machineIpAddressMismatchErrorMessage: "Hostname/IP stimmt nicht ueberein",
    skillsNotAvailableErrorMessage: "Skills nicht verfuegbar",
    operationPendingWarningMessage:
      "Der Verbindungsstatus ist noch IDLE oder IN_PROGRESS - Die Quelle kann in der Liste erscheinen, wenn der Vorgang erfolgreich abgeschlossen wird.",
    machineCreationTimeoutWarningMessage:
      "Die Erstellung der Maschine hat das Zeitlimit überschritten. Das Gateway hat nicht rechtzeitig geantwortet. Wenn die Maschine nicht in der Maschinenliste erscheint, versuchen Sie bitte, sie erneut zu erstellen.",
    operationTimedOutErrorMessage: "Die Verbindung ist abgelaufen.",
    operationFailureErrorMessage: "Die Verbindung ist fehlgeschlagen.",
    operationBackendFailureErrorMessage:
      "Beim Pruefen der Verbindung ist ein Backend-Fehler aufgetreten.",
    createMachineFailedErrorMessage: "Maschine konnte nicht erstellt werden.",
    certificateGenerationFailedErrorMessage:
      "Das Zertifikat konnte nicht erzeugt werden. Bitte versuchen Sie es erneut.",
    skillInstallSuccessMessage: "Maschinen-Skills erfolgreich installiert",
    invalidPortErrorMessage:
      "Bitte geben Sie einen gueltigen Port zwischen 1 und 65535 ein",
    rpcDsnLabel: "DSN",
    rpcPortHelpText:
      "Dies ist der Port, den das Gateway verwendet, um auf den RPC-Server der Maschine für Things-Twin-Daten zuzugreifen.",
    invalidRpcDsnErrorMessage: "Bitte geben Sie eine gueltige DSN-Adresse ein",
    showProtocol: "Protokoll anzeigen",
    hideProtocol: "Protokoll ausblenden",
    getSupport: "Support erhalten",
    statusIconAltText: "Statussymbol",
    opcUaErrorDetailsTitle: "OPC-UA-Fehlerdetails",
    opcUaConnectionSetupIdleTitle:
      "Der OPC-UA-Verbindungsaufbau blieb im Leerlaufzustand",
    opcUaConnectionSetupIdleDetail:
      "Der OPC-UA-Verbindungsaufbau zum Server {endpoint} wurde nicht abgeschlossen und blieb im Zustand Idle. Es wurde keine Verbindung zum OPC-UA-Server hergestellt.",
    opcUaConnectionSetupIdleRecommendedAction:
      "Prüfen Sie, ob der OPC-UA-Server läuft, die Endpunktkonfiguration korrekt ist und eine Netzwerkverbindung verfügbar ist. Versuchen Sie es anschließend erneut.",
    titleSummary: "Maschine hinzufügen (Zusammenfassung)",
    sectionTitleSummary: "Maschinen-Setup Zusammenfassung",
    summaryStatusLabel: "Status",
    summaryInstalledSkillsLabel: "Installierte Skills",
    summaryFailedSkillsLabel: "Fehlgeschlagene Skills",
    summarySkippedSkillsLabel: "Übersprungene Skills",
    summaryFinishButton: "Weitere Maschine hinzufügen",
    summaryGoToNewMachineButton: "Zur neuen Maschine",
    summaryRetryButton: "Erneut versuchen",
    summaryUpdateAndRetryButton:
      "Aktualisieren und Installation erneut versuchen",
    installedSkillLabel: "Installiert",
    installedSkillTooltip: "Der Skill {skill} ist installiert.",
    summaryStatusSuccess: "Setup abgeschlossen",
    summaryStatusPartialSuccess: "Setup mit einigen Fehlern abgeschlossen",
    summaryStatusFailed: "Setup fehlgeschlagen",
    summaryStatusSkipped: "Setup ohne Maschinen-Skills abgeschlossen",
    thingsSupportTitle: "Things Support",
    thingsSupportDescription:
      "Diese Maschinenfunktion ermöglicht es Benutzern, die Mensch-Maschine-Schnittstelle (HMI) einer Maschine sicher und in Echtzeit aus der Ferne so anzusehen und zu steuern, als wären sie vor Ort.",
    thingsTwinTitle: "Things Twin",
    thingsTwinDescription:
      "Der digitale Zwilling erstellt eine virtuelle Darstellung der Maschine, die kontinuierlich mit Live-Daten synchronisiert wird, um die Leistung zu überwachen, zu analysieren und zu optimieren.",
    readMoreLabel: "Mehr anzeigen",
    readLessLabel: "Weniger anzeigen",
    vncPortLabel: "VNC-Port",
    vncPortPlaceholder: "z. B. 5900",
    vncPortHelpText:
      "Dies ist der Port, den das Gateway verwendet, um auf den VNC-Server der Maschine für die HMI-Bildschirmfreigabe zuzugreifen.",
    portIsAvailableLabel: "Port ist verfügbar",
    clearPortButtonLabel: "Port löschen",
    opcUaPortHelpText:
      "Dies ist der Port, den das Gateway verwendet, um auf den OPC-UA-Server der Maschine für Things-Twin-Daten zuzugreifen.",
    connectionSectionTitle: "Verbindung",
    connectionOpcUaDescription:
      "Geben Sie den Listening-Port des OPC-UA-Servers an.",
    opcUaPortPlaceholder: "z. B. 4840",
    encryptionSectionTitle: "Verschlüsselung",
    encryptionDescription:
      "Legen Sie fest, wie Client-Server-Daten geschützt werden, einschließlich Signierung und Verschlüsselung.",
    loginSectionTitle: "Anmeldung",
    loginDescription:
      "Legen Sie fest, wie sich das Gateway beim Server identifiziert: anonym oder mit Anmeldedaten.",
    applicationCertificateSectionTitle: "Anwendungszertifikat",
    applicationCertificateDescription:
      "Verwenden Sie ein Zertifikat, um einen sicheren Kanal zwischen Gateway und Server herzustellen.",
    securityModeLabel: "Modus",
    securityPolicyLabel: "Richtlinie",
    usernameLabel: "Benutzername",
    passwordLabel: "Passwort",
    clientCertificateLabel: "Client-Zertifikat (Base64)",
    clientCertificatePrivateKeyLabel:
      "Privater Schlüssel des Client-Zertifikats (Base64)",
    clientCertificatePasswordLabel: "Passwort des Client-Zertifikats",
    serverPublicKeyLabel: "Öffentlicher Serverschlüssel",
    anonymousTab: "Anonym",
    userLoginTab: "Benutzeranmeldung",
    pleaseFixFieldsLabel: "Bitte beheben Sie die folgenden Felder",
  },
};

export const addNewMachineDrawerModalZhHans = {
  [pageNameKey]: {
    title: "添加机器 (1/2)",
    sectionTitle: "机器上线 (1/2)",
    stepGateway: "网关",
    stepMachine: "机器",
    stepThingsOs: "Things OS",
    gatewayLabel: "连接到机器的网关",
    gatewayPlaceholder: "搜索网关...",
    noGatewaysFound: "未找到网关",
    machineNameLabel: "机器名称",
    hostOrIpAddressLabel: "机器主机名/IP地址",
    help: "帮助",
    machineNameHelpText: "您将在 Things OS 中通过此名称找到您的机器。",
    ipAddressHelpText: "输入网关可用于通过网络访问机器的主机名或 IP 地址。",
    connectButton: "连接",
    invalidIpAddressErrorMessage: "请输入有效的主机名或IP地址",
    continueMachineSkillsButton: "继续到机器技能",
    titleStepTwo: "添加机器 (2/2)",
    sectionTitleStepTwo: "机器技能 (2/2)",
    machineSkillsDescription:
      "机器检测识别出以下机器技能：{skills}。启用所需技能以完成设置。",
    installAndFinishSetupButton: "安装并完成设置",
    finishSetupWithoutSkillsButton: "不安装机器技能并完成设置",
    machineIpReachable: "机器主机名/IP可达",
    checkingMachineAvailability: "正在检查机器可用性",
    creatingMachine: "正在创建机器",
    skillsIdentified: "已识别技能",
    noMachineSkillsFoundMessage: "未自动找到机器技能（例如 OPC UA、VNC）",
    machineIpAddressMismatchErrorMessage: "主机名/IP不匹配",
    skillsNotAvailableErrorMessage: "技能不可用",
    operationPendingWarningMessage:
      "连接状态仍为 IDLE 或 IN_PROGRESS - 如果流程成功完成，源可能会出现在列表中。",
    machineCreationTimeoutWarningMessage:
      "机器创建超时。网关未能及时响应。如果机器未出现在机器列表中，请尝试重新创建。",
    operationTimedOutErrorMessage: "连接已超时。",
    operationFailureErrorMessage: "连接失败。",
    operationBackendFailureErrorMessage: "检查连接时发生后端错误。",
    createMachineFailedErrorMessage: "创建机器失败。",
    certificateGenerationFailedErrorMessage: "证书生成失败，请重试。",
    skillInstallSuccessMessage: "机器技能安装成功",
    invalidPortErrorMessage: "请输入1到65535之间的有效端口",
    rpcDsnLabel: "DSN",
    rpcPortHelpText:
      "这是网关用于访问机器的 RPC 服务器以获取 Things Twin 数据的端口。",
    invalidRpcDsnErrorMessage: "请输入有效的DSN地址",
    showProtocol: "显示协议",
    hideProtocol: "隐藏协议",
    getSupport: "获取支持",
    statusIconAltText: "状态图标",
    opcUaErrorDetailsTitle: "OPC UA 错误详情",
    opcUaConnectionSetupIdleTitle: "OPC UA 连接设置一直处于空闲状态",
    opcUaConnectionSetupIdleDetail:
      "与服务器 {endpoint} 的 OPC UA 连接设置未完成，并一直处于空闲状态。未能与 OPC UA 服务器建立连接。",
    opcUaConnectionSetupIdleRecommendedAction:
      "请确认 OPC UA 服务器正在运行、端点配置正确且网络连接可用，然后重试。",
    titleSummary: "添加机器 (摘要)",
    sectionTitleSummary: "机器设置摘要",
    summaryStatusLabel: "状态",
    summaryInstalledSkillsLabel: "已安装技能",
    summaryFailedSkillsLabel: "失败技能",
    summarySkippedSkillsLabel: "已跳过技能",
    summaryFinishButton: "添加另一台机器",
    summaryGoToNewMachineButton: "转到新机器",
    summaryRetryButton: "重试",
    summaryUpdateAndRetryButton: "更新并重试安装",
    installedSkillLabel: "已安装",
    installedSkillTooltip: "{skill} 技能已安装。",
    summaryStatusSuccess: "设置完成",
    summaryStatusPartialSuccess: "设置完成但有部分失败",
    summaryStatusFailed: "设置失败",
    summaryStatusSkipped: "未安装机器技能，设置完成",
    thingsSupportTitle: "Things Support",
    thingsSupportDescription:
      "此机器技能可让用户安全地实时远程查看和控制机器的人机界面，就像身临其境一样。",
    thingsTwinTitle: "Things Twin",
    thingsTwinDescription:
      "数字孪生会创建机器的虚拟模型，并持续与实时数据同步，以监控、分析和优化性能。",
    readMoreLabel: "查看更多",
    readLessLabel: "收起",
    vncPortLabel: "VNC 端口",
    vncPortPlaceholder: "例如 5900",
    vncPortHelpText:
      "这是网关用于访问机器的 VNC 服务器以进行 HMI 屏幕共享的端口。",
    portIsAvailableLabel: "端口可用",
    clearPortButtonLabel: "清除端口",
    opcUaPortHelpText:
      "这是网关用于访问机器的 OPC UA 服务器以获取 Things Twin 数据的端口。",
    connectionSectionTitle: "连接",
    connectionOpcUaDescription: "指定 OPC UA 服务器的监听端口。",
    opcUaPortPlaceholder: "例如 4840",
    encryptionSectionTitle: "加密",
    encryptionDescription:
      "选择客户端与服务器之间数据的保护方式，包括签名和加密。",
    loginSectionTitle: "登录",
    loginDescription: "设置网关如何向服务器进行身份验证：匿名或使用凭据。",
    applicationCertificateSectionTitle: "应用程序证书",
    applicationCertificateDescription:
      "使用证书在网关与服务器之间建立安全通道。",
    securityModeLabel: "模式",
    securityPolicyLabel: "策略",
    usernameLabel: "用户名",
    passwordLabel: "密码",
    clientCertificateLabel: "客户端证书 (Base64)",
    clientCertificatePrivateKeyLabel: "客户端证书私钥 (Base64)",
    clientCertificatePasswordLabel: "客户端证书密码",
    serverPublicKeyLabel: "服务器公钥",
    anonymousTab: "匿名",
    userLoginTab: "用户登录",
    pleaseFixFieldsLabel: "请修正以下字段",
  },
};

export const addNewMachineDrawerModalIt = {
  [pageNameKey]: {
    title: "Aggiunta macchina (1/2)",
    sectionTitle: "Onboarding macchina (1/2)",
    stepGateway: "Gateway",
    stepMachine: "Macchina",
    stepThingsOs: "Things OS",
    gatewayLabel: "Gateway collegato alla macchina",
    gatewayPlaceholder: "Cerca gateway...",
    noGatewaysFound: "Nessun gateway trovato",
    machineNameLabel: "Nome macchina",
    hostOrIpAddressLabel: "Indirizzo hostname/IP primario della macchina",
    help: "Aiuto",
    machineNameHelpText:
      "Troverai la tua macchina con questo nome in Things OS.",
    ipAddressHelpText:
      "Inserisci l'hostname o l'indirizzo IP che il gateway può utilizzare per accedere alla macchina tramite la rete.",
    connectButton: "Connetti",
    invalidIpAddressErrorMessage: "Inserisci un hostname o indirizzo IP valido",
    continueMachineSkillsButton: "Continua alle skill della macchina",
    titleStepTwo: "Aggiunta macchina (2/2)",
    sectionTitleStepTwo: "Skill macchina (2/2)",
    machineSkillsDescription:
      "Il rilevamento della macchina ha identificato le seguenti skill: {skills}. Abilita le skill necessarie per completare la configurazione.",
    installAndFinishSetupButton: "Installa e completa configurazione",
    finishSetupWithoutSkillsButton: "Completa senza skill macchina",
    machineIpReachable: "Hostname/IP macchina raggiungibile",
    checkingMachineAvailability: "Verifica della disponibilità della macchina",
    creatingMachine: "Creazione della macchina in corso",
    skillsIdentified: "Skill identificate",
    noMachineSkillsFoundMessage:
      "Nessuna skill macchina (ad es. OPC UA, VNC) trovata automaticamente",
    machineIpAddressMismatchErrorMessage: "L'hostname/IP non corrisponde",
    skillsNotAvailableErrorMessage: "Skill non disponibili",
    operationPendingWarningMessage:
      "Lo stato della connessione e ancora IDLE o IN_PROGRESS - L'origine potrebbe comparire nell'elenco se il processo viene completato correttamente.",
    machineCreationTimeoutWarningMessage:
      "La creazione della macchina è scaduta. Il gateway non ha risposto in tempo. Se la macchina non compare nell'elenco delle macchine, prova a crearla di nuovo.",
    operationTimedOutErrorMessage: "Connessione scaduta.",
    operationFailureErrorMessage: "Connessione non riuscita.",
    operationBackendFailureErrorMessage:
      "Si e verificato un errore backend durante il controllo della connessione.",
    createMachineFailedErrorMessage: "Creazione della macchina non riuscita.",
    certificateGenerationFailedErrorMessage:
      "Generazione del certificato non riuscita. Riprova.",
    skillInstallSuccessMessage: "Skill macchina installate con successo",
    invalidPortErrorMessage: "Inserisci una porta valida tra 1 e 65535",
    rpcDsnLabel: "DSN",
    rpcPortHelpText:
      "Questa è la porta che il gateway utilizza per accedere al server RPC della macchina per i dati di Things Twin.",
    invalidRpcDsnErrorMessage: "Inserisci un indirizzo DSN valido",
    showProtocol: "Mostra protocollo",
    hideProtocol: "Nascondi protocollo",
    getSupport: "Ottieni supporto",
    statusIconAltText: "Icona di stato",
    opcUaErrorDetailsTitle: "Dettagli errore OPC UA",
    opcUaConnectionSetupIdleTitle:
      "La configurazione della connessione OPC UA è rimasta inattiva",
    opcUaConnectionSetupIdleDetail:
      "La configurazione della connessione OPC UA al server {endpoint} non è stata completata ed è rimasta nello stato Inattivo. Non è stata stabilita alcuna connessione al server OPC UA.",
    opcUaConnectionSetupIdleRecommendedAction:
      "Verifica che il server OPC UA sia in esecuzione, che la configurazione dell'endpoint sia corretta e che la connessione di rete sia disponibile. Quindi riprova.",
    titleSummary: "Aggiunta macchina (Riepilogo)",
    sectionTitleSummary: "Riepilogo configurazione macchina",
    summaryStatusLabel: "Stato",
    summaryInstalledSkillsLabel: "Skill installate",
    summaryFailedSkillsLabel: "Skill non riuscite",
    summarySkippedSkillsLabel: "Skill saltate",
    summaryFinishButton: "Aggiungi un'altra macchina",
    summaryGoToNewMachineButton: "Vai alla nuova macchina",
    summaryRetryButton: "Riprova",
    summaryUpdateAndRetryButton: "Aggiorna e riprova l'installazione",
    installedSkillLabel: "Installata",
    installedSkillTooltip: "La skill {skill} è installata.",
    summaryStatusSuccess: "Configurazione completata",
    summaryStatusPartialSuccess: "Configurazione completata con alcuni errori",
    summaryStatusFailed: "Configurazione fallita",
    summaryStatusSkipped: "Configurazione completata senza skill",
    thingsSupportTitle: "Things Support",
    thingsSupportDescription:
      "Questa funzionalità della macchina consente agli utenti di visualizzare e controllare in modo sicuro da remoto, in tempo reale, l'interfaccia uomo-macchina, come se fossero sul posto.",
    thingsTwinTitle: "Things Twin",
    thingsTwinDescription:
      "Il Digital Twin crea una rappresentazione virtuale della macchina, sincronizzata continuamente con i dati in tempo reale per monitorare, analizzare e ottimizzare le prestazioni.",
    readMoreLabel: "Leggi di più",
    readLessLabel: "Leggi di meno",
    vncPortLabel: "Porta VNC",
    vncPortPlaceholder: "es. 5900",
    vncPortHelpText:
      "Questa è la porta che il gateway utilizza per accedere al server VNC della macchina per la condivisione dello schermo HMI.",
    portIsAvailableLabel: "La porta è disponibile",
    clearPortButtonLabel: "Cancella porta",
    opcUaPortHelpText:
      "Questa è la porta che il gateway utilizza per accedere al server OPC UA della macchina per i dati di Things Twin.",
    connectionSectionTitle: "Connessione",
    connectionOpcUaDescription:
      "Specifica la porta di ascolto del server OPC UA.",
    opcUaPortPlaceholder: "es. 4840",
    encryptionSectionTitle: "Crittografia",
    encryptionDescription:
      "Seleziona come proteggere i dati client-server, inclusi firma e crittografia.",
    loginSectionTitle: "Accesso",
    loginDescription:
      "Imposta come il gateway si identifica al server: in modo anonimo o con credenziali.",
    applicationCertificateSectionTitle: "Certificato applicativo",
    applicationCertificateDescription:
      "Usa un certificato per stabilire un canale sicuro tra il gateway e il server.",
    securityModeLabel: "Modalità",
    securityPolicyLabel: "Criterio",
    usernameLabel: "Nome utente",
    passwordLabel: "Password",
    clientCertificateLabel: "Certificato client (Base64)",
    clientCertificatePrivateKeyLabel:
      "Chiave privata del certificato client (Base64)",
    clientCertificatePasswordLabel: "Password del certificato client",
    serverPublicKeyLabel: "Chiave pubblica del server",
    anonymousTab: "Anonimo",
    userLoginTab: "Accesso utente",
    pleaseFixFieldsLabel: "Correggi i seguenti campi",
  },
};

export const addNewMachineDrawerModalEs = {
  [pageNameKey]: {
    title: "Agregando máquina (1/2)",
    sectionTitle: "Incorporación de la máquina (1/2)",
    stepGateway: "Gateway",
    stepMachine: "Máquina",
    stepThingsOs: "Things OS",
    gatewayLabel: "Gateway conectado a la máquina",
    gatewayPlaceholder: "Buscar gateways...",
    noGatewaysFound: "No se encontraron gateways",
    machineNameLabel: "Nombre de la máquina",
    hostOrIpAddressLabel: "Dirección principal de hostname/IP de la máquina",
    help: "Ayuda",
    machineNameHelpText: "Encontrará su máquina con este nombre en Things OS.",
    ipAddressHelpText:
      "Introduce el hostname o la dirección IP que el gateway puede utilizar para acceder a la máquina a través de la red.",
    connectButton: "Conectar",
    invalidIpAddressErrorMessage: "Introduce un hostname o dirección IP válida",
    continueMachineSkillsButton: "Continuar a habilidades de la maquina",
    titleStepTwo: "Agregando máquina (2/2)",
    sectionTitleStepTwo: "Habilidades de la máquina (2/2)",
    machineSkillsDescription:
      "La detección de la máquina identificó las siguientes habilidades: {skills}. Habilite las habilidades necesarias para completar la configuración.",
    installAndFinishSetupButton: "Instalar y finalizar configuracion",
    finishSetupWithoutSkillsButton: "Finalizar sin habilidades de maquina",
    machineIpReachable: "Hostname/IP de la maquina alcanzable",
    checkingMachineAvailability: "Comprobando la disponibilidad de la máquina",
    creatingMachine: "Creando máquina",
    skillsIdentified: "Habilidades identificadas",
    noMachineSkillsFoundMessage:
      "No se encontraron habilidades de máquina automáticamente (por ejemplo, OPC UA, VNC)",
    machineIpAddressMismatchErrorMessage: "El hostname/IP no coincide",
    skillsNotAvailableErrorMessage: "Habilidades no disponibles",
    operationPendingWarningMessage:
      "El estado de la conexion sigue en IDLE o IN_PROGRESS - El origen podria aparecer en la lista si el proceso finaliza correctamente.",
    machineCreationTimeoutWarningMessage:
      "Se agotó el tiempo de espera para crear la máquina. El gateway no respondió a tiempo. Si la máquina no aparece en la lista de máquinas, intenta crearla de nuevo.",
    operationTimedOutErrorMessage: "La conexion ha expirado.",
    operationFailureErrorMessage: "La conexion ha fallado.",
    operationBackendFailureErrorMessage:
      "Se produjo un error de backend al comprobar la conexion.",
    createMachineFailedErrorMessage: "Error al crear la maquina.",
    certificateGenerationFailedErrorMessage:
      "Error al generar el certificado. Intentelo de nuevo.",
    skillInstallSuccessMessage: "Habilidades de maquina instaladas con exito",
    invalidPortErrorMessage: "Introduce un puerto válido de 2 a 5 dígitos",
    rpcDsnLabel: "DSN",
    rpcPortHelpText:
      "Este es el puerto que el gateway utiliza para acceder al servidor RPC de la máquina para los datos de Things Twin.",
    invalidRpcDsnErrorMessage: "Introduce una direccion DSN valida",
    showProtocol: "Mostrar protocolo",
    hideProtocol: "Ocultar protocolo",
    getSupport: "Obtener soporte",
    statusIconAltText: "Icono de estado",
    opcUaErrorDetailsTitle: "Detalles del error OPC UA",
    opcUaConnectionSetupIdleTitle:
      "La configuración de conexión OPC UA permaneció inactiva",
    opcUaConnectionSetupIdleDetail:
      "La configuración de conexión OPC UA con el servidor {endpoint} no se completó y permaneció en estado inactivo. No se estableció ninguna conexión con el servidor OPC UA.",
    opcUaConnectionSetupIdleRecommendedAction:
      "Verifica que el servidor OPC UA esté en ejecución, que la configuración del endpoint sea correcta y que la conexión de red esté disponible. Luego, vuelve a intentarlo.",
    titleSummary: "Agregando máquina (Resumen)",
    sectionTitleSummary: "Resumen de configuración de la máquina",
    summaryStatusLabel: "Estado",
    summaryInstalledSkillsLabel: "Habilidades instaladas",
    summaryFailedSkillsLabel: "Habilidades fallidas",
    summarySkippedSkillsLabel: "Habilidades omitidas",
    summaryFinishButton: "Agregar otra máquina",
    summaryGoToNewMachineButton: "Ir a la nueva máquina",
    summaryRetryButton: "Reintentar",
    summaryUpdateAndRetryButton: "Actualizar y reintentar la instalación",
    installedSkillLabel: "Instalada",
    installedSkillTooltip: "La habilidad {skill} está instalada.",
    summaryStatusSuccess: "Configuración completada",
    summaryStatusPartialSuccess: "Configuración completada con algunos fallos",
    summaryStatusFailed: "Configuración fallida",
    summaryStatusSkipped: "Configuración completada sin habilidades de máquina",
    thingsSupportTitle: "Things Support",
    thingsSupportDescription:
      "Esta habilidad permite a los usuarios ver y controlar de forma segura y remota, en tiempo real, la interfaz hombre-máquina de una máquina, como si estuvieran allí.",
    thingsTwinTitle: "Things Twin",
    thingsTwinDescription:
      "El gemelo digital crea una representación virtual de la máquina, sincronizada continuamente con datos en tiempo real para supervisar, analizar y optimizar su rendimiento.",
    readMoreLabel: "Leer más",
    readLessLabel: "Leer menos",
    vncPortLabel: "Puerto VNC",
    vncPortPlaceholder: "p. ej., 5900",
    vncPortHelpText:
      "Este es el puerto que el gateway utiliza para acceder al servidor VNC de la máquina para compartir la pantalla HMI.",
    portIsAvailableLabel: "El puerto está disponible",
    clearPortButtonLabel: "Borrar puerto",
    opcUaPortHelpText:
      "Este es el puerto que el gateway utiliza para acceder al servidor OPC UA de la máquina para los datos de Things Twin.",
    connectionSectionTitle: "Conexión",
    connectionOpcUaDescription:
      "Especifica el puerto de escucha del servidor OPC UA.",
    opcUaPortPlaceholder: "p. ej., 4840",
    encryptionSectionTitle: "Cifrado",
    encryptionDescription:
      "Selecciona cómo se protegen los datos cliente-servidor, incluidos la firma y el cifrado.",
    loginSectionTitle: "Inicio de sesión",
    loginDescription:
      "Define cómo se identifica la pasarela ante el servidor: de forma anónima o con credenciales.",
    applicationCertificateSectionTitle: "Certificado de aplicación",
    applicationCertificateDescription:
      "Usa un certificado para establecer un canal seguro entre la pasarela y el servidor.",
    securityModeLabel: "Modo",
    securityPolicyLabel: "Política",
    usernameLabel: "Nombre de usuario",
    passwordLabel: "Contraseña",
    clientCertificateLabel: "Certificado de cliente (Base64)",
    clientCertificatePrivateKeyLabel:
      "Clave privada del certificado de cliente (Base64)",
    clientCertificatePasswordLabel: "Contraseña del certificado de cliente",
    serverPublicKeyLabel: "Clave pública del servidor",
    anonymousTab: "Anónimo",
    userLoginTab: "Inicio de sesión de usuario",
    pleaseFixFieldsLabel: "Corrija los siguientes campos",
  },
};

export const addNewMachineDrawerModalNl = {
  [pageNameKey]: {
    title: "Machine toevoegen (1/2)",
    sectionTitle: "Machine-onboarding (1/2)",
    stepGateway: "Gateway",
    stepMachine: "Machine",
    stepThingsOs: "Things OS",
    gatewayLabel: "Gateway verbonden met de machine",
    gatewayPlaceholder: "Zoek gateways...",
    noGatewaysFound: "Geen gateways gevonden",
    machineNameLabel: "Machinenaam",
    hostOrIpAddressLabel: "Primair hostname/IP-adres van machine",
    help: "Help",
    machineNameHelpText: "U vindt uw machine onder deze naam in Things OS.",
    ipAddressHelpText:
      "Voer de hostnaam of het IP-adres in dat de gateway kan gebruiken om via het netwerk toegang te krijgen tot de machine.",
    connectButton: "Verbinden",
    invalidIpAddressErrorMessage: "Voer een geldige hostnaam of IP-adres in",
    continueMachineSkillsButton: "Doorgaan naar machine-skills",
    titleStepTwo: "Machine toevoegen (2/2)",
    sectionTitleStepTwo: "Machine-skills toevoegen",
    machineSkillsDescription:
      "De machinedetectie heeft de volgende machine-skills geïdentificeerd: {skills}. Schakel de vereiste skills in om de configuratie te voltooien.",
    installAndFinishSetupButton: "Installeren en configuratie afronden",
    finishSetupWithoutSkillsButton:
      "Configuratie afronden zonder machine-skills",
    machineIpReachable: "Machine-hostname/IP bereikbaar",
    checkingMachineAvailability: "Beschikbaarheid van machine controleren",
    creatingMachine: "Machine wordt aangemaakt",
    skillsIdentified: "Skills gedetecteerd",
    noMachineSkillsFoundMessage:
      "Geen machine-skills (bijv. OPC UA, VNC) automatisch gevonden",
    machineIpAddressMismatchErrorMessage: "Hostname/IP-adres komt niet overeen",
    skillsNotAvailableErrorMessage: "Skills niet beschikbaar",
    operationPendingWarningMessage:
      "De verbindingsstatus is nog IDLE of IN_PROGRESS - De bron kan in de lijst verschijnen als het proces succesvol wordt afgerond.",
    machineCreationTimeoutWarningMessage:
      "Time-out bij het aanmaken van de machine. De gateway heeft niet op tijd gereageerd. Als de machine niet in de machinelijst verschijnt, probeer deze dan opnieuw aan te maken.",
    operationTimedOutErrorMessage: "De verbinding is verlopen.",
    operationFailureErrorMessage: "De verbinding is mislukt.",
    operationBackendFailureErrorMessage:
      "Er is een backendfout opgetreden bij het controleren van de verbinding.",
    createMachineFailedErrorMessage: "Machine aanmaken is mislukt.",
    certificateGenerationFailedErrorMessage:
      "Het certificaat kon niet worden gegenereerd. Probeer het opnieuw.",
    skillInstallSuccessMessage: "Machine-skills succesvol geïnstalleerd",
    invalidPortErrorMessage: "Voer een geldige poort met 2 tot 5 cijfers in",
    rpcDsnLabel: "DSN",
    rpcPortHelpText:
      "Dit is de poort die de gateway gebruikt om toegang te krijgen tot de RPC-server van de machine voor Things Twin-gegevens.",
    invalidRpcDsnErrorMessage: "Voer een geldig DSN-adres in",
    showProtocol: "Protocol tonen",
    hideProtocol: "Protocol verbergen",
    getSupport: "Ondersteuning krijgen",
    statusIconAltText: "Statuspictogram",
    opcUaErrorDetailsTitle: "OPC UA-foutdetails",
    opcUaConnectionSetupIdleTitle:
      "De OPC UA-verbindingsconfiguratie bleef inactief",
    opcUaConnectionSetupIdleDetail:
      "De OPC UA-verbindingsconfiguratie met server {endpoint} is niet voltooid en bleef in de status Idle. Er is geen verbinding met de OPC UA-server tot stand gebracht.",
    opcUaConnectionSetupIdleRecommendedAction:
      "Controleer of de OPC UA-server actief is, de endpointconfiguratie klopt en de netwerkverbinding beschikbaar is. Probeer het daarna opnieuw.",
    titleSummary: "Machine toevoegen (Samenvatting)",
    sectionTitleSummary: "Samenvatting machine-onboarding",
    summaryStatusLabel: "Status",
    summaryInstalledSkillsLabel: "Geïnstalleerde skills",
    summaryFailedSkillsLabel: "Mislukte skills",
    summarySkippedSkillsLabel: "Overgeslagen skills",
    summaryFinishButton: "Nog een machine toevoegen",
    summaryGoToNewMachineButton: "Ga naar de nieuwe machine",
    summaryRetryButton: "Opnieuw proberen",
    summaryUpdateAndRetryButton: "Installatie bijwerken en opnieuw proberen",
    installedSkillLabel: "Geïnstalleerd",
    installedSkillTooltip: "Skill {skill} is geïnstalleerd.",
    summaryStatusSuccess: "Configuratie voltooid",
    summaryStatusPartialSuccess: "Configuratie voltooid met enkele fouten",
    summaryStatusFailed: "Configuratie mislukt",
    summaryStatusSkipped: "Configuratie voltooid zonder machine-skills",
    thingsSupportTitle: "Things Support",
    thingsSupportDescription:
      "Deze machine-skill stelt gebruikers in staat om de HMI van een machine veilig en in realtime op afstand te bekijken en te bedienen, alsof ze zelf ter plaatse zijn.",
    thingsTwinTitle: "Things Twin",
    thingsTwinDescription:
      "De Digital Twin maakt een virtuele representatie van de machine die continu wordt gesynchroniseerd met live data om prestaties te monitoren, analyseren en optimaliseren.",
    readMoreLabel: "Meer lezen",
    readLessLabel: "Minder lezen",
    vncPortLabel: "VNC-poort",
    vncPortPlaceholder: "bijv. 5900",
    vncPortHelpText:
      "Dit is de poort die de gateway gebruikt om toegang te krijgen tot de VNC-server van de machine voor HMI-scherm delen.",
    portIsAvailableLabel: "Poort is beschikbaar",
    clearPortButtonLabel: "Poort wissen",
    opcUaPortHelpText:
      "Dit is de poort die de gateway gebruikt om toegang te krijgen tot de OPC UA-server van de machine voor Things Twin-gegevens.",
    connectionSectionTitle: "Verbinding",
    connectionOpcUaDescription: "Geef de luisterpoort van de OPC UA-server op.",
    opcUaPortPlaceholder: "bijv. 4840",
    encryptionSectionTitle: "Versleuteling",
    encryptionDescription:
      "Selecteer hoe client-servergegevens worden beschermd, inclusief ondertekening en versleuteling.",
    loginSectionTitle: "Aanmelden",
    loginDescription:
      "Stel in hoe de gateway zich bij de server identificeert: anoniem of met aanmeldgegevens.",
    applicationCertificateSectionTitle: "Applicatiecertificaat",
    applicationCertificateDescription:
      "Gebruik een certificaat om een beveiligd kanaal tussen de gateway en de server tot stand te brengen.",
    securityModeLabel: "Modus",
    securityPolicyLabel: "Beleid",
    usernameLabel: "Gebruikersnaam",
    passwordLabel: "Wachtwoord",
    clientCertificateLabel: "Clientcertificaat (Base64)",
    clientCertificatePrivateKeyLabel: "Private key clientcertificaat (Base64)",
    clientCertificatePasswordLabel: "Wachtwoord clientcertificaat",
    serverPublicKeyLabel: "Openbare serversleutel",
    anonymousTab: "Anoniem",
    userLoginTab: "Gebruikerslogin",
    pleaseFixFieldsLabel: "Corrigeer de volgende velden",
  },
};

export const addNewMachineDrawerModalTr = {
  [pageNameKey]: {
    title: "Ekleme Makinası (1/2)",
    sectionTitle: "Makineye Ekleme (1/2)",
    stepGateway: "Geçit",
    stepMachine: "Makine",
    stepThingsOs: "Şeyler İşletim Sistemi",
    gatewayLabel: "Makineye Bağlı Ağ Geçidi",
    gatewayPlaceholder: "Ağ geçitlerini ara...",
    noGatewaysFound: "Ağ geçidi bulunamadı",
    machineNameLabel: "Makine Adı",
    hostOrIpAddressLabel: "Makine Birincil Ana Bilgisayar Adı/IP Adresi",
    help: "Yardım",
    machineNameHelpText: "Makinenizi Things OS'ta bu isimle bulacaksınız.",
    ipAddressHelpText:
      "Ağ geçidinin ağ üzerinden makineye erişmek için kullanabileceği ana bilgisayar adını veya IP adresini girin.",
    connectButton: "Bağlamak",
    invalidIpAddressErrorMessage:
      "Lütfen geçerli bir ana bilgisayar adı veya IP adresi girin",
    continueMachineSkillsButton: "Makine Becerilerine Devam Et",
    titleStepTwo: "Ekleme Makinası (2/2)",
    sectionTitleStepTwo: "Makine Becerileri Ekleme",
    machineSkillsDescription:
      "Makine algılaması şu makine becerilerini tanımladı: {skills}. Kurulumu tamamlamak için gerekli becerileri etkinleştirin.",
    installAndFinishSetupButton: "Kurulumu Yükleyin ve Bitirin",
    finishSetupWithoutSkillsButton:
      "Kurulumu Makine Becerileri Olmadan Bitirin",
    machineIpReachable: "Makine ana bilgisayar adı/IP'ye erişilebilir",
    checkingMachineAvailability: "Makine kullanılabilirliğini kontrol etme",
    creatingMachine: "Makine oluşturuluyor",
    skillsIdentified: "Tanımlanan beceriler",
    noMachineSkillsFoundMessage:
      "Otomatik olarak hiçbir makine becerisi bulunamadı (ör. OPC UA, VNC)",
    machineIpAddressMismatchErrorMessage: "Ana makine adı/IP eşleşmiyor",
    skillsNotAvailableErrorMessage: "Beceriler mevcut değil",
    operationPendingWarningMessage:
      "Bağlantı durumu hala IDLE veya IN_PROGRESS durumunda - İşlem başarıyla tamamlanırsa kaynağın listede göründüğünü görebilirsiniz.",
    machineCreationTimeoutWarningMessage:
      "Makine oluşturma zaman aşımına uğradı. Ağ geçidi zamanında yanıt vermedi. Makine listede görünmüyorsa lütfen yeniden oluşturmayı deneyin.",
    operationTimedOutErrorMessage: "Bağlantı zaman aşımına uğradı.",
    operationFailureErrorMessage: "Bağlantı başarısız oldu.",
    operationBackendFailureErrorMessage:
      "Bağlantı kontrol edilirken bir arka uç hatası oluştu.",
    createMachineFailedErrorMessage: "Makine oluşturulamadı.",
    certificateGenerationFailedErrorMessage:
      "Sertifika oluşturulamadı. Lütfen tekrar deneyin.",
    skillInstallSuccessMessage: "Makine becerileri başarıyla yüklendi",
    invalidPortErrorMessage:
      "Lütfen 2 ila 5 haneli geçerli bir bağlantı noktası girin",
    rpcDsnLabel: "DSN",
    rpcPortHelpText:
      "Bu, ağ geçidinin, Things Twin Data için makinenin RPC sunucusuna erişmek için kullandığı bağlantı noktasıdır.",
    invalidRpcDsnErrorMessage: "Lütfen geçerli bir DSN adresi girin",
    showProtocol: "Protokolü Göster",
    hideProtocol: "Protokolü Gizle",
    getSupport: "Destek Alın",
    statusIconAltText: "Durum simgesi",
    opcUaErrorDetailsTitle: "OPC UA hata ayrıntıları",
    opcUaConnectionSetupIdleTitle:
      "OPC UA bağlantı kurulumu boşta durumunda kaldı",
    opcUaConnectionSetupIdleDetail:
      "{endpoint} sunucusuna OPC UA bağlantı kurulumu tamamlanmadı ve Boşta durumunda kaldı. OPC UA sunucusuna bağlantı kurulamadı.",
    opcUaConnectionSetupIdleRecommendedAction:
      "OPC UA sunucusunun çalıştığını, uç nokta yapılandırmasının doğru olduğunu ve ağ bağlantısının kullanılabilir olduğunu doğrulayın. Ardından yeniden deneyin.",
    titleSummary: "Ekleme Makinesi (Özet)",
    sectionTitleSummary: "Makineye Ekleme Özeti",
    summaryStatusLabel: "Durum",
    summaryInstalledSkillsLabel: "Yüklü beceriler",
    summaryFailedSkillsLabel: "Başarısız beceriler",
    summarySkippedSkillsLabel: "Atlanan beceriler",
    summaryFinishButton: "Başka Bir Makine Ekle",
    summaryGoToNewMachineButton: "Yeni Makineye Git",
    summaryRetryButton: "Yeniden dene",
    summaryUpdateAndRetryButton: "Güncelle ve yüklemeyi yeniden dene",
    installedSkillLabel: "Yüklendi",
    installedSkillTooltip: "{skill} becerisi yüklendi.",
    summaryStatusSuccess: "Kurulum tamamlandı",
    summaryStatusPartialSuccess: "Kurulum bazı hatalarla tamamlandı",
    summaryStatusFailed: "Kurulum başarısız oldu",
    summaryStatusSkipped: "Kurulum makine becerileri olmadan tamamlandı",
    thingsSupportTitle: "Şeyler Desteği",
    thingsSupportDescription:
      "Bu makine becerisi, kullanıcılara bir makinenin insan-makine arayüzünü sanki oradaymış gibi gerçek zamanlı olarak uzaktan, güvenli bir şekilde görüntüleme ve kontrol etme olanağı sağlar.",
    thingsTwinTitle: "Şeyler İkiz",
    thingsTwinDescription:
      "Dijital İkiz, performansı izlemek, analiz etmek ve optimize etmek için makinenin canlı verilerle sürekli olarak senkronize edilen sanal bir temsilini oluşturur.",
    readMoreLabel: "Devamını oku",
    readLessLabel: "Daha az oku",
    vncPortLabel: "VNC Bağlantı Noktası",
    vncPortPlaceholder: "örn. 5900",
    vncPortHelpText:
      "Bu, ağ geçidinin HMI ekran paylaşımı için makinenin VNC sunucusuna erişmek için kullandığı bağlantı noktasıdır.",
    portIsAvailableLabel: "Bağlantı noktası mevcut",
    clearPortButtonLabel: "Bağlantı noktasını temizle",
    opcUaPortHelpText:
      "Bu, ağ geçidinin, Things Twin Data için makinenin OPC UA sunucusuna erişmek için kullandığı bağlantı noktasıdır.",
    connectionSectionTitle: "Bağlantı",
    connectionOpcUaDescription:
      "OPC UA sunucusunun dinleme bağlantı noktasını belirtin.",
    opcUaPortPlaceholder: "örn. 4840",
    encryptionSectionTitle: "Şifreleme",
    encryptionDescription:
      "İstemci-sunucu verilerinin imzalama ve şifreleme dahil nasıl korunacağını seçin.",
    loginSectionTitle: "Giriş",
    loginDescription:
      "Ağ geçidinin sunucuya nasıl kimlik doğrulayacağını belirleyin: anonim olarak veya kimlik bilgileriyle.",
    applicationCertificateSectionTitle: "Uygulama Sertifikası",
    applicationCertificateDescription:
      "Ağ geçidi ile sunucu arasında güvenli bir kanal oluşturmak için sertifika kullanın.",
    securityModeLabel: "Mod",
    securityPolicyLabel: "Politika",
    usernameLabel: "Kullanıcı adı",
    passwordLabel: "Şifre",
    clientCertificateLabel: "İstemci Sertifikası (Base64)",
    clientCertificatePrivateKeyLabel:
      "İstemci Sertifikası Özel Anahtarı (Base64)",
    clientCertificatePasswordLabel: "İstemci Sertifikası Şifresi",
    serverPublicKeyLabel: "Sunucu Genel Anahtarı",
    anonymousTab: "Anonim",
    userLoginTab: "Kullanıcı Girişi",
    pleaseFixFieldsLabel: "Lütfen aşağıdaki alanları düzeltin",
  },
};
